<nav class="main-nav dark stick-fixed">
  <div class="full-wrapper relative">
    <!-- Logo ( * your text or image into link tag *) -->
    <div class="nav-logo-wrap local-scroll">
      <a href="/" class="logo">
        <img src="assets/images/logo_top.png" alt="Bolão Pé na Cova" />
      </a>
    </div>
    <div class="mobile-nav" role="button" tabindex="0" (click)="toggleMenu()">
      <i class="fa fa-bars"></i>
      <span class="sr-only">Menu</span>
    </div>
    <app-header-menu *ngIf="showMenu" />
  </div>
</nav>
